import axios from "axios";

export const searchBlacklist = async (params) => {
    return axios
        .get("admin/blacklist/search", { params })
        .then((response) => response.data.result || [])
        .catch((error) => {
            console.error("Failed to search blacklist");
            console.error(error);
            return [];
        });
};

export const getBrandsForEmail = async (email) => {
    return axios
        .get("admin/blacklist/brands", { params: { email } })
        .then((response) => response.data.result || [])
        .catch((error) => {
            console.error("Failed to look up brands for email");
            console.error(error);
            return [];
        });
};

export const addBlacklistEntry = async (entry) => {
    return axios
        .post("admin/blacklist", entry)
        .then((response) => response.data)
        .catch((error) => {
            console.error("Failed to add blacklist entry");
            console.error(error);
            return { success: false, message: "Request failed." };
        });
};

export const deactivateBlacklistEntry = async (id) => {
    return axios
        .delete(`admin/blacklist/${id}`)
        .then((response) => response.data)
        .catch((error) => {
            console.error("Failed to deactivate blacklist entry");
            console.error(error);
            return { success: false, message: "Request failed." };
        });
};
